<template>
  <div class="login-container">
    <el-form
      class="login-form"
      autoComplete="on"
      :model="loginForm"
      :rules="loginRules"
      ref="loginForm"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">
          <i class="el-icon el-icon-ali-logo logo"></i>碗碟管理登陆
        </h3>
        <!-- <lang-select class="set-language"></lang-select> -->
      </div>
      <el-form-item prop="username" class="form">
        <span class="svg-container svg-container_login">
          <!-- <svg-icon icon-class="user" /> -->
        </span>
        <el-input
          name="username"
          type="text"
          prefix-icon="el-icon-ali-user"
          v-model="loginForm.username"
          autoComplete="on"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          name="password"
          :type="passwordType"
          prefix-icon="el-icon-ali-passwd"
          @keyup.enter.native="handleLogin"
          v-model="loginForm.password"
          autoComplete="on"
          placeholder="密码"
        >
          <el-button
            type="text"
            class="btn"
            @mouseenter.native="onHover"
            @mouseleave.native="onMouseLeave"
            slot="suffix"
            ><i class="el-icon el-icon-ali-yanjing"></i
          ></el-button>
        </el-input>
      </el-form-item>
      <el-button
        type="primary"
        :icon="loading ? 'el-icon-loading' : ''"
        style="width:100%;margin-bottom:30px;"
        @click.native.prevent="handleLogin"
        >登陆</el-button>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable */

import {apiRequestLogin} from '@/api';

export default {
  components: {},
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      callback();
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error("The password can not be less than 1 digits"));
      } else {
        callback();
      }
    };
    return {
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ]
      },
      loginForm: {
        username: "",
        password: ""
      },
      passwordType: "password",
      loading: false,
      showDialog: false
    };
  },
  computed: {
    lastRoutesName() {
      return this.$route.query.lastRoutesName;
    }
  },
  methods: {
    onHover() {
      // console.log('asdasdsadsadsa');
      this.passwordType = "";
    },
    onMouseLeave() {
      this.passwordType = "password";
    },
    async handleLogin() {
      this.loading = true
      try {
        const res = await apiRequestLogin(
          this.loginForm.username,
          this.loginForm.password
        );
        this.loading = false;
        this.$store.dispatch("handleLogin", {
          userinfo: {
            username: this.loginForm.username,
            api_key: res.api_key,
            userGroup: res.user_group || 10
          },
        });
        this.$router.push({
          name: 'admin',
          query: {
            lastRoutesName: this.lastRoutesName
          }
        });
      } catch (e) {
        if (e.message === "-1") {
          this.loading = false;
          this.$message.error("登陆失败, 账号或密码错误");
        } else {
          this.$message.error("登陆失败" + e.message);
        }
      }

      // apiRequestLogin({
      //     username: that.loginForm.username,
      //     passWord: that.loginForm.password
      //   })
      //   .then(data => {
      //     if (data.state_code === 0) {
      //       that.$store.dispatch("handleLogin", {
      //         userinfo: {
      //           username: that.loginForm.username,
      //           api_key: data.data.api_key,
      //           // userId: data.data.user_id || 10
      //           userGroup: data.data.user_group || 10
      //         },
      //       });
      //       that.$router.push({
      //         path: '/',
      //         query: {
      //           lastRoutesName: this.lastRoutesName
      //         }
      //       });
      //     } else if (data.state_code === -1) {
      //       this.loading = false
      //       that.$message({
      //         message: "登陆失败, 账号或密码错误",
      //         type: "error"
      //       });
      //     }
      //   });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.login-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #283443;
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 80%;
    max-width: 400px;
    margin: 150px auto;
    .title-container {
      position: relative;
      .title {
        font-size: 26px;
        color: #eee;
        margin: 0px auto 20px auto;
        text-align: center;
        font-weight: bold;
        .logo {
          display: inline-block;
          margin-right: 10px;
          vertical-align: top;
          font-size: 40px;
        }
      }
    }
    .btn {
      color: #222;
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>
